import { CreativityContentData } from 'src/types/banner/banner-interfaces';
import { isPromptCreativity } from '../types/banner';

export const getDisplayContent = (creativity: CreativityContentData): string => {
  if (isPromptCreativity(creativity)) {
    return creativity.title || 'Nueva creatividad';
  }

  // reel/video no tienen `title` ni `bannerType` → usan `caption` + label por tipo.
  const c = creativity as { type?: string; caption?: string };
  if (c.type === 'reel' || c.type === 'video') {
    return c.caption || (c.type === 'reel' ? 'Reel' : 'Video');
  }

  // Para creatividades en general
  return creativity.title || `Creatividad ${creativity.bannerType}`;
};
